import axiosClient from "@/services/shared/api/axios-client";
import config from "@/config/config";
import { resetPasswordMock } from "./resetPassword.mocks";

const API_URL = "/password/reset";

// Real API implementation
const resetPasswordApi = async (token: string, email: string, newPassword: string) => {
  await axiosClient.post(API_URL, { token, email, newPassword });
};

// Export service that selects between real and mock implementation
export const resetPassword = config.selectApi(resetPasswordApi, resetPasswordMock);
